module.exports = __webpack_public_path__ + "static/media/exclamation-triangle.b7229871.svg";